import { render, staticRenderFns } from "./menubutton.vue?vue&type=template&id=2302e8c8&scoped=true&"
import script from "./menubutton.vue?vue&type=script&lang=js&"
export * from "./menubutton.vue?vue&type=script&lang=js&"
import style0 from "./menubutton.vue?vue&type=style&index=0&id=2302e8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2302e8c8",
  null
  
)

export default component.exports